module.exports = __webpack_public_path__ + "static/media/non_admin.ce841d81.png";